import { createFileRoute } from '@tanstack/react-router';
import { MaeShell } from '@/shared/desktop/MaeShell';
import { McpConsent } from '@/features/mcp/McpConsent';

/**
 * `/mcp/authorize?request=<id>` — il consenso a un assistente (server MCP, `docs/FE-TO-BE-MCP-v1.md`).
 * Ci arriva il browser rediretto da `GET /oauth/authorize` del BE; chi non è entrato passa dal login
 * e torna qui con la query intera (guardia di `_app`).
 */
export const Route = createFileRoute('/_app/mcp/authorize')({
  validateSearch: (s: Record<string, unknown>): { request?: string } => ({
    request: typeof s.request === 'string' && s.request ? s.request : undefined,
  }),
  component: McpAuthorizePage,
});

function McpAuthorizePage() {
  const { request } = Route.useSearch();
  return (
    <MaeShell>
      <McpConsent requestId={request} />
    </MaeShell>
  );
}
